import { menu } from './menu';
import { router } from './router';
import { components } from './components';

export const Dilenske = {
	menu,
	router,
	components,
};
